module.exports = __webpack_public_path__ + "static/assets/843a7304dd570643aa90c3395d67cf49.gif";